import { useTranslation } from "react-i18next";

// Kompakter UI-Sprach-Umschalter (DE | EN). Persistiert über die
// i18next-Detection in localStorage (Key `ca_lang`).
export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = (i18n.language || "de").split("-")[0];

  const langs = [
    { code: "de", label: "DE" },
    { code: "en", label: "EN" },
  ];

  return (
    <span className="inline-flex items-center rounded-md border border-ca-border overflow-hidden text-[10px] font-black uppercase tracking-widest">
      {langs.map((l) => (
        <button
          key={l.code}
          type="button"
          onClick={() => void i18n.changeLanguage(l.code)}
          aria-pressed={current === l.code}
          className={`px-2 py-1 transition ${
            current === l.code
              ? "bg-ca-accent text-ca-brand"
              : "bg-ca-card text-ca-surface-muted hover:text-ca-surface-ink"
          }`}
        >
          {l.label}
        </button>
      ))}
    </span>
  );
}
